import { useCallback, useEffect, useState } from "react";
import { JSX } from "react";

import {
  ComponentsOverride,
  CpqCore,
  OverridableComponentsKeys,
  StandardComponents,
} from "@4pace-cpq/core";

import { Providers } from "./Providers";
import { AppHeader } from "./components/AppHeader/AppHeader";
import { CustomCartIdRouteComponent } from "./components/CustomCartIdRouteComponent/CustomCartIdRouteComponent";
import ConfiguratorContainer from "./configurator/ConfiguratorContainer";
import { CustomIndexRouteComponent } from "./cpq/overrides/CustomIndexRouteComponent/CustomIndexRouteComponent";
import { CustomOpportunityRouteComponent } from "./cpq/overrides/CustomOpportunityRouteComponent/CustomOpportunityRouteComponent";
import QuoteDetailsViewPageHeader from "./cpq/overrides/QuoteDetailsViewPageHeader/QuoteDetailsViewPageHeader";
import { prettyLogger } from "./prettyLogger";
import { customPalette } from "./theme/theme";

prettyLogger(
  `FE Version ${__CPQ_CORE_FE_VERSION__}`,
  customPalette.primary.main,
);

let params = new URLSearchParams(document.location.search);
let urlLanguage = params.get("language");
const savedLanguage = localStorage.getItem("selectedLanguageId");
export const appLanguage = urlLanguage || savedLanguage || "en-US"; //TODO Remove imports

export function App(): JSX.Element {
  const [isLoggedIntoEasy, setIsLoggedIntoEasy] = useState<boolean>(false);
  const [isCheckingLogin, setIsCheckingLogin] = useState<boolean>(true);
  const [preferredName, setPreferredName] = useState<string>("");

  const checkLogin = useCallback(async () => {
    setIsCheckingLogin(true);
    let response;
    try {
      response = await fetch("/api/Easy/CheckLoginState", {
        method: "GET",
      });
      const data = await response.json();
      if (typeof data?.string === "string") {
        setPreferredName(data.string);
      }
      if (response.status === 200) {
        setIsLoggedIntoEasy(true);
      } else {
        setIsLoggedIntoEasy(false);
        console.log("false");
      }
    } catch (error) {
      console.warn(error);
      setIsLoggedIntoEasy(false);
    }
    setIsCheckingLogin(false);
    console.log({ isLoggedIntoEasy });
  }, [isLoggedIntoEasy]);

  useEffect(() => {
    checkLogin();
  }, [checkLogin]);

  if (isCheckingLogin) {
    return <></>;
  }

  const componentsOverride: ComponentsOverride = {
    [OverridableComponentsKeys.QuoteDetailsViewPageHeader]:
      QuoteDetailsViewPageHeader,
    [OverridableComponentsKeys.MainHeader]: () => (
      <AppHeader
        isLoggedIntoEasy={isLoggedIntoEasy}
        preferredName={preferredName}
        setIsLoggedIntoEasy={setIsLoggedIntoEasy}
      />
    ),
    [OverridableComponentsKeys.GoBackToOpportunitiesButton]: () => <></>,
    [OverridableComponentsKeys.ConfiguratorRouteComponent]: () => (
      <ConfiguratorContainer />
    ),

    [OverridableComponentsKeys.OpportunityRouteComponent]: () => (
      <CustomOpportunityRouteComponent checkLogin={checkLogin} />
    ),
    [OverridableComponentsKeys.QuotesRouteComponent]: () => (
      <div>
        <StandardComponents.QuotesRouteComponent />
      </div>
    ),
    [OverridableComponentsKeys.CartIdRouteComponent]: () => (
      <CustomCartIdRouteComponent isLoggedIntoEasy={isLoggedIntoEasy} />
    ),
    [OverridableComponentsKeys.IndexRouteComponent]: CustomIndexRouteComponent,
  };

  return (
    <Providers>
      <CpqCore
        languageCode={appLanguage}
        componentsOverride={componentsOverride}
        enableDevTools={false}
      />
    </Providers>
  );
}
